import React, { useState } from "react"
import { locale, constants, DropDown, DropDownItem } from "@albelli/photoselector"
import FlexIcon from "@albelli/photoselector/lib/ImagePicker/Graphic/flex-icon.svg"
import SquareIcon from "@albelli/photoselector/lib/ImagePicker/Graphic/square-icon.svg"

interface LayoutSelectorProps {
  store: any
}

const getLayoutList = (): DropDownItem[] => {
  return [
    { id: "flex", title: locale.get().layout.flex },
    { id: "square", title: locale.get().layout.square }
  ]
}

const LayoutSelector = (props: LayoutSelectorProps) => {
  const { store } = props
  const [selectedLayout, setSelectedLayout] = useState<string>("flex")

  const onSelect = (item: DropDownItem) => {
    setSelectedLayout(item.id)
    store.setLayoutId(item.id)
  }

  return window.innerWidth > constants.mobileWidth ? (
    <DropDown list={getLayoutList()} selectedId={selectedLayout} onSelect={onSelect} position="bottom" className="photoselector-dropdown-layout">
      <div className="photoselector-filter-component layout">
        <img className="photoselector-viewmode-icon" src={selectedLayout === "flex" ? FlexIcon : SquareIcon} />
        <div className="photoselector-sorting-selected photoselector-sort-value" data-tam="select-view">
          <span hidden={selectedLayout === "square"} data-tam="square-view">
            {locale.get().layout.flex}
          </span>
          <span hidden={selectedLayout === "flex"} data-tam="flex-view">
            {locale.get().layout.square}
          </span>
        </div>
      </div>
    </DropDown>
  ) : null
}

export default LayoutSelector
